import { NewUser, UserSubscritpion } from './../../model/newUser';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiEndpoints, Grades, CookieNames, BasicRoutes, PaymentSteps, Status } from './../../constant';
import { ShoppingCartService, HttpClientService, emailValidator, mobileValidator, emptyField, CookieManagerService, ErrorManagerService, CustomObserverService, RegistrationFeeTokenService } from '../../../shared';
import { Component, OnInit, Input } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { debug } from 'util';
import { SubscriptionInfoService } from '../subscription-info-service.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { checkNoChangesView } from '@angular/core/src/view/view';
import { PaperSet, OnlinePaper } from '../../model'
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;


@Component({
  selector: 'app-subscription-info',
  templateUrl: './subscription-info.component.html',
  styleUrls: ['./subscription-info.component.css']
})

export class SubscriptionInfoComponent implements OnInit {
  @Input() paperSet: PaperSet;
  public districts: Array<Object> = [];
  public totalPrice: number = 0;
  public lengthItems: number = 0;
  public billingInfo: FormGroup;
  public grades: Array<Object> = [];
  public user: NewUser = new NewUser({});
  public userMobile: string = null;
  public userSubscription = new UserSubscritpion();
  public selectedPackage: any;
  public apiRequstWaiter: boolean = true;
  private userCurrentPackageId: string;
  private times: number = 0;
  private alive = true;
  private access_token = null;
  public imageProfile: any;
  public isValidpaymentCode: string = null;
  public userId: string;
  public redirectUrl: any;
  public isMobile: boolean = false;
  public isMobileRedirection: Boolean = false;
  public paymentType: string;
  public PaperPrice: number = 0;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private shoppingCartService: ShoppingCartService,
    private httpClientService: HttpClientService,
    public fb: FormBuilder,
    private cookieManagerService: CookieManagerService,
    private translateService: TranslateService,
    private errorManagerService: ErrorManagerService,
    private customObserverService: CustomObserverService,
    private registrationFeeTokenService: RegistrationFeeTokenService,
    private subscriptionInfoService: SubscriptionInfoService,
    private localStorageService: LocalStorageService,
    private santhy: DomSanitizer

  ) {
    this.billingInfo = fb.group({
      'firstName': ['', Validators.compose([Validators.required, emptyField])],
      'lastName': ['', Validators.compose([Validators.required, emptyField])],
      'grade': ['', Validators.compose([Validators.required])],
      'district': ['', Validators.compose([Validators.required])],
      'mobile': ['', Validators.compose([Validators.required, mobileValidator])],
    });

  }

  ngOnInit() {

 this.getonlinepaperprice();
    this.loadDistricts();
    this.grades = Grades;
    window.scrollTo(0, 0);
    this.subscriptionInfoService.currentMessage.subscribe(message => this.selectedPackage = message);

    // To mobile redirection
    if (this.route.children && this.route.children.length > 0) {
      this.route.children.forEach((activatedRoute: Params) => {

        if (activatedRoute && activatedRoute.params && activatedRoute.params._value['token'] || false) {
          this.access_token = activatedRoute.params._value['token'];
        }
        if (this.access_token != null) {
          if (activatedRoute && activatedRoute.params && activatedRoute.params._value['token'] === 'onetime') {
            this.paymentType = 'onetime';
            this.fetchSubscriptionData();
          }
          else {
            this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaymentMobileAutenticate, { [ApiEndpoints.paymentcode]: this.access_token }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
              this.customObserverService.setPaymentCode(true);
              this.cookieManagerService.deleteAll();
              this.localStorageService.clearAll();
              if (response.user.image) {
                this.imageProfile = response.user.image;
              } else {
                this.imageProfile = '/assets/img/default-avatar.svg';
              }
              let userDetails = response.user;
              delete userDetails.image;
              this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(userDetails));
              this.cookieManagerService.setCookie(CookieNames.loginKey, response.token, false);

              this.isMobile = true;
              this.localStorageService.set(CookieNames.userImage, this.imageProfile);
              if (response.user.firstname) {
                this.customObserverService.setName(response.user.firstname);
              } else {
                this.customObserverService.setName(response.user.mobile);
              }
              this.customObserverService.setData(this.imageProfile);
              this.customObserverService.setData(this.imageProfile);
              this.isValidpaymentCode = response;
              this.userId = response.user._id;

              this.subscriptionInfoService.setSelectedPackage(response.requestedSubscriptionDetails);
              this.subscriptionInfoService.setCurrentSubscriptionPackage(response.currentSubscriptionId);
              this.selectedPackage = this.subscriptionInfoService.getSelectedPackage();
              let packageId = this.localStorageService.get(CookieNames.userPackageId);
              this.userCurrentPackageId = response.currentSubscriptionId;
              this.getUserById();

            }, error => {
              let err = error.json();
              this.access_token = null;
              let that = this;
              swal({
                title: this.translateService.instant('PAYMENT_NOT_SUCCESS_HEAD'),
                html: this.translateService.instant('PAYMENT_NOT_SUCCESS_BODY'),
                confirmButtonText: this.translateService.instant('PAYMENT_NOT_SUCCESS_BTN'),
                type: 'error'
              }).then(() => {
                window.open('grade5://grade5.lk');
              }, function (dismiss) {
                window.open('grade5://grade5.lk');
              });
            });
          }
        }
        else {

        }
      });
    }
    else {
      this.fetchSubscriptionData();
    }
  }

  fetchSubscriptionData() {
    this.selectedPackage = this.subscriptionInfoService.getSelectedPackage();
    let packageId = this.localStorageService.get(CookieNames.userPackageId);
    this.userCurrentPackageId = packageId ? packageId.toString() : "";
    this.getUserById();
  }

  /**
   *
   * load districts
   * @memberof BillingInfoComponent
   */
  loadDistricts() {
    this.httpClientService.get(ApiEndpoints.getDistricts).subscribe(response => {
      this.districts = response;
    }, error => {

    });
  }

  getTrustedUrl(url) {
    return this.santhy.bypassSecurityTrustUrl(url);
  }

  getonlinepaperprice() {

    var url = ApiEndpoints.getOnlinePaperSets;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(url, { [ApiEndpoints.paperType]: 'ONLINE_EXAM', [ApiEndpoints.pageNumber]: 1, [ApiEndpoints.paperUserStatus]: 'undefined' }), null).subscribe(
      res => {
        this.PaperPrice = res.papersets[0];

      });
  }



  /**
   *
   * update user info and create subscription
   *
   */
  updateUser() {
    let that = this;
    that.apiRequstWaiter = false;
    that.user.setting.mobile.push({ 'data': that.userMobile });
    that.userSubscription.status = "SUBSCRIBE";
    that.user.userSubscription = that.userSubscription;

    if (this.paymentType === 'onetime') {
      that.apiRequstWaiter = true;
      that.userSubscription.subscriptionPackageId = '5c815cb01ac3280b2d330a2e';
      this.subscriptionInfoService.subscribeForLive(that.userMobile, that.userSubscription.subscriptionPackageId).then((response: any) => {
        swal.close();
        if (response.success) {
          this.showMessage('SW_MESSAGE1', 'Success', 'success', true);
        }
        else {
          this.showMessage('SW_MESSAGE1', 'you will notfiy', 'error', true);
        }

        if (this.isMobile) {
          this.rederectUrl();
        }
        else {
          that.router.navigate([BasicRoutes.onlinePapers]);
        }
      });
    } else {
      that.userSubscription.subscriptionPackageId = that.selectedPackage._id;
      that.httpClientService.authPaymentPut(ApiEndpoints.updateUser, that.user).subscribe(response => {
        that.apiRequstWaiter = true;
        if (response.user.subscriptionStatusMessage === "SUBSCRIPTION_WAITING") {
          this.showMessage('INFORMATION','SUBSCRIPTION_WAITING', 'info', false );
          swal.showLoading();
          this.subscriptionInfoService.checkSubscriptionStatus(0, that.userMobile, that.userSubscription.subscriptionPackageId, "subscribe").then((result: any) => {
            swal.close();
            if(result.code === 200){
              response.user.subscriptionPackageId = result.packageId;
              this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(response.user));
              that.subscriptionInfoService.setCurrentSubscriptionPackage(result.packageId);
              this.showMessage('SW_MESSAGE1', 'SUBSCRIPTION_SUCESS', 'success', true);
              that.router.navigate([BasicRoutes.mypapers]);
            }
            else if(result.code === 206){
              this.showMessage('SW_HEAD2', 'SUBSCRIPTION_INSUFFIENT_BALANCE', 'error', true);
            }
            else{
              this.showMessage('SW_HEAD2', 'YOU_WILL_NOTIFY_UNSUBSCRIPTION', 'error', true);
              that.router.navigate([BasicRoutes.mypapers]);
            }
          });
        }
        else {
          this.showMessage('SW_HEAD2', 'SUBSCRIPTION_ERROR', 'error', true);
          that.router.navigate([BasicRoutes.clientExams]);
        }
      }, error => {
        that.apiRequstWaiter = true;
        let errorMesg = error.json().message;
        if (error.json().code === 4022) {
          this.showMessage('SW_HEAD2', 'SUBSCRIPTION_ERROR', 'error', true);
        } else if (errorMesg == "ALREADY_SUBSCRIBED_THIS_PACKAGE") {
          this.showMessage('SW_HEAD2', 'ALREADY_SUBSCRIBED_ERROR', 'error', true);
        } else if (errorMesg == "HAVE_DEFAULT_FREE_PACKAGE") {
          this.showMessage('SW_HEAD2', 'ALREADY_SUBSCRIBED_ERROR', 'error', true);
        }
        else if (errorMesg === "The account balance is insufficient.") {
          this.showMessage('SW_HEAD2', 'SUBSCRIPTION_INSUFFIENT_BALANCE', 'error', true);
        }
        else {
          this.showMessage('SW_HEAD2', 'TRY_AGAIN', 'error', true);
        }
        if (this.isMobile) {
          this.redirectUrl();
        }
        else {
          that.router.navigate([BasicRoutes.clientExams]);
        }
      });

    }
  }
  /**
   * get User By Id
   * @param {any} id
   * @memberof BillingInfoComponent
   */
  getUserById() {
    let id = this.cookieManagerService.getCookie(CookieNames.username, false);
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    let user = userObj ? JSON.parse(userObj.toString()) : null;
    if (user) {
      id = user._id;
    }
    else {
      this.router.navigate(['home/exams']);
    }
    id ? true : id = this.registrationFeeTokenService.getRegistrationToken();
    if (id) {

      this.user._id = id;
      this.httpClientService.authPaymentGet(ApiEndpoints.getUserById, null).subscribe(response => {

        this.user = new NewUser(response.user);
        if (this.user.setting.mobile && this.user.setting.mobile.length > 0) {
          this.userMobile = this.user.setting.mobile[this.user.setting.mobile.length - 1].data;
        }
        else {
          this.userMobile = this.user.mobile;
        }
        if (!this.user.grade) {
          this.user.grade = "";
        }
        if (!this.user.district) {
          this.user.district = "";
        }

      }, error => {
        if (error.json().code === 4022) {
          this.showMessage('SW_HEAD2', 'SW_BODY2', 'error', false);
        } else {
          this.errorManagerService.setError(error);
        }
      }
      );

    }
  }

  showMessage(header, content, type, allowOutsideClick) {
    swal({
      title: this.translateService.instant(header),
      html: this.translateService.instant(content),
      type: type,
      allowOutsideClick: allowOutsideClick
    });
  }

  rederectUrl() {
    window.open('grade5://grade5.lk/payment/5a681abe8a728241cf8cc828?papers=true', '_system', 'location=no,clearsessioncache=no,clearcache=no');
  }

}





// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/subscription-packages/subscription-info/subscription-info.component.ts